export enum RoutesEnum {
  calendar = '/calendar',
  rankings = '/ranking',
  weekly = '/weekly',
  weeklyPickemId = '/weekly/:pickemId',
}
